import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=ba4417ae&scoped=true&"
import script from "./NotFoundView.vue?vue&type=script&lang=js&"
export * from "./NotFoundView.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=ba4417ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4417ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
